module.exports = __webpack_public_path__ + "static/media/undraw_connected_world_wuay.068b1c34.svg";